import { render } from "./SelectPhoto.vue?vue&type=template&id=db8e9cfc&scoped=true"
import script from "./SelectPhoto.vue?vue&type=script&lang=js"
export * from "./SelectPhoto.vue?vue&type=script&lang=js"

import "./SelectPhoto.vue?vue&type=style&index=0&id=db8e9cfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8e9cfc"]])

export default __exports__